@if (loading | async) {
  <div class="loading-overlay">
    <mat-spinner mode="indeterminate" diameter="24" />
  </div>
}

<div class="component-container" [ngClass]="{ 'full-size': fullsize, grid: isGrid }">
  @for (c of components | keyvalue; track $index) {
    @if (c.value.type !== "Chart") {
      <div
        #component
        class="component"
        tabindex="0"
        [class]="c.value.type | lowercase"
        [class.custom-scroll]="(c.value.type | lowercase) !== 'table'"
        [attr.size]="c.value.size"
        [style]="c.value.gridStyle"
      >
        @switch (c.value.type) {
          @case ("Form") {
            <app-form
              [title]="c.value.title"
              [fields]="c.value['fields']"
              [attachments]="c.value['attachments']"
              (event)="c.value['onEvent']($event)"
              (statechange)="c.value['onStateChange']($event)"
              (openAttachment)="c.value['openAttachments']($event)"
              [options]="c.value['options']"
              [buttons]="c.value['buttons']"
              [mode]="c.value['mode']"
              [credits]="c.value['credits']"
              [collection]="c.value['fieldCollection']"
              [buttonenabled]="c.value['buttonenabled']"
              [dialogRef]="dialogRef"
            />
          }
          @case ("Table") {
            <app-table
              (event)="c.value['onEvent']($event)"
              [id]="c.value.id"
              [contentid]="c.value['contentid']"
              [headers]="c.value['headers']"
              [root]="c.value['root']"
              [filters]="c.value['activeFilters']"
              [options]="c.value['options']"
              [buttons]="c.value['buttons']"
              [setstatusaction]="c.value['statusactionid']"
              [searchactionid]="c.value['searchactionid']"
              [sortactionid]="c.value['sortactionid']"
              [searchkeys]="c.value['searchkeys']"
            />
          }
          @case ("Caption") {
            <app-caption />
          }
          @case ("Tile") {
            <app-tile [tiles]="c.value['tiles']" />
          }
        }
      </div>
    }
  }
  @if (hasCharts) {
    <div class="component chart-container">
      @for (c of components | keyvalue; track $index) {
        <div tabindex="0" [class]="c.value.type | lowercase">
          @switch (c.value.type) {
            @case ("Chart") {
              <app-chart [charts]="c.value['charts']" />
            }
          }
        </div>
      }
    </div>
  }
</div>
